import baustein from "baustein";

export default baustein.register("hide-on-click", {
    setupEvents(add) {
        add("click", this._onClick);
    },

    _onClick(event) {
        event.preventDefault();
        this.el.classList.add("hidden");
    },
});
